import { signOut as signOutAmplify } from '../utils/amplifyAuthHelpers';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'src/components/ui/BrandSelect';
import { Actions as LOGINACTIONS } from '../../store/actions/authenticationActions';
import { Actions as HELPACTIONS } from '../../store/actions/helpActions';
import { Actions as ORGANISATIONACTIONS } from '../../store/actions/organisationActions';
import { Actions as SIDEBARACTIONS } from '../../store/actions/sidebarActions';
import { CustomOption } from '../Common/ReusableComponents/Reusable';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Menu, Info, User, ChevronDown, Contact, Key } from 'lucide-react';
import { shellHomePath, shellKind } from '../utils/managementShell';
import CyfLockup from '../utils/CyfLockup';

const Navbar = ({
  organisations,
  organisationOptions,
  selectedOrganisation,
  updateOrganisation,
  toggleSidebar,
  toggleHelp,
  fullName,
  showHelpSidebar,
  logout,
  branding,
  brandingAssetPreview,
  currentOrg,
  currentOrganisation,
  drgWhiteLabel,
  getOrganisation,
  profile,
  isWhiteLabelApp,
}) => {
  const { body } = branding.fonts?.[0].font || {};
  const { logo, appTopLeftLogo, name } = branding || {};
  const headerLogo = brandingAssetPreview?.logo || appTopLeftLogo || logo;
  const showCyfLockup = !isWhiteLabelApp && !brandingAssetPreview?.logo;

  const [showUserMenu, toggleUserMenu] = useState(false);

  let history = useHistory();

  const signOut = async () => {
    try {
      localStorage.removeItem('Organisation');
      localStorage.removeItem('orgDetails');
      await signOutAmplify();
      history.push('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 992) toggleSidebar();
  }, [toggleSidebar]);

  const updateOrg = (organisationOption) => {
    const orgDetails = organisations.find((item) => item.id === organisationOption.value);
    updateOrganisation(orgDetails);
    getOrganisation();
    if (window.location.pathname === `/organisations/${currentOrg}`) {
      history.push(`/organisations/${organisationOption.value}`);
    }
    localStorage.setItem('Organisation', organisationOption.value);
    if (orgDetails) localStorage.setItem('orgDetails', JSON.stringify(orgDetails));
    const kind = shellKind(orgDetails, profile);
    if (kind) {
      history.push(shellHomePath(kind));
    }
  };

  return (
    <div className={`z-[11] fixed h-[80px] border-0 border-b border-[var(--border)] flex w-full shadow-sm`} style={{ background: 'var(--header-background, #FDFCF9)' }}>
      <div className='brand bg-[var(--main-logo-background)]'>
        <div
          className='logo logo-box'
          onClick={() => {
            if (drgWhiteLabel) window.location.href = 'https://digitalrg.com/dashboard';
            else {
              const kind = shellKind(currentOrganisation, profile);
              history.push(kind ? shellHomePath(kind) : '/');
            }
          }}>
          {showCyfLockup ? (
            <CyfLockup variant='onDark' size='header' />
          ) : (
            <img src={headerLogo} alt={name} className='h-auto max-h-[52px] w-auto max-w-[200px] object-contain' />
          )}
        </div>
        <div className='group absolute float-left mt-[23px] ml-[-15px] rounded-full w-[32px] h-[32px] bg-[var(--menu-toggle)] hover:bg-[var(--menu-toggle-hover)] right-[-15px] hidden md:block transition-colors'>
          <div
            onClick={toggleSidebar}
            className='cursor-pointer inline-flex items-center justify-center w-full h-full text-[var(--hamburger-icon)] group-hover:text-[var(--hamburger-icon-hover)]'>
            <Menu size={15} strokeWidth={1.5} />
          </div>
        </div>
        <div className='block md:hidden group absolute float-left left-[10px] rounded-full w-[32px] h-[32px] bg-[var(--menu-toggle)] hover:bg-[var(--menu-toggle-hover)]'>
          <div
            onClick={toggleSidebar}
            className='cursor-pointer inline-flex items-center justify-center w-full h-full text-[var(--hamburger-icon)] group-hover:text-[var(--hamburger-icon-hover)]'>
            <Menu size={15} strokeWidth={1.5} />
          </div>
        </div>
        <div className='toggle-right-box md:hidden block'>
          <div
            onClick={toggleHelp}
            className='text-[var(--info-button)] hover:text-[var(--info-button-hover)] p-0 inline-block cursor-pointer transition-colors'>
            <Info size={32} strokeWidth={1.5} />
          </div>
        </div>
      </div>
      <div className='flex items-center justify-end grow px-0'>
        <ul className='nav pull-right top-menu flex items-center gap-3'>
          <li className='dropdown'>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  id='UserDropdown'
                  variant='ghost'
                  className='flex items-center rounded-full text-sm h-10 px-4 bg-[var(--navbar-user-dropdown)] text-foreground hover:bg-muted transition-colors'>
                  <User size={16} strokeWidth={1.5} className='mr-2' />
                  <span style={{ fontFamily: body }}>
                    {fullName}
                  </span>
                  <ChevronDown size={12} strokeWidth={1.5} className='ml-2 text-muted-foreground' />
                </Button>
              </PopoverTrigger>
              <PopoverContent className='w-48 mt-2 p-3 text-[13px]'>
                <div className='group flex items-center justify-start p-2 rounded-md hover:bg-gray-100 cursor-pointer'>
                  <a
                    id='UserDropdown-Profile'
                    href='/profile'
                    className='flex w-full items-center gap-2'
                    onClick={() => {
                      history.push('/profile');
                      toggleUserMenu(!showUserMenu);
                    }}>
                    <Contact size={18} strokeWidth={1.5} className='group-hover:text-[var(--secondary)]' />
                    <span>Profile</span>
                  </a>
                </div>
                <div className='group flex items-center justify-start p-2 rounded-md hover:bg-gray-100 cursor-pointer'>
                  <a
                    id='UserDropdown-LogOut'
                    href='/'
                    className='flex w-full items-center gap-2'
                    onClick={(e) => {
                      e.preventDefault();
                      signOut();
                      logout(null);
                    }}>
                    <Key size={18} strokeWidth={1.5} className='group-hover:text-[var(--secondary)]' />
                    <span>Log Out</span>
                  </a>
                </div>
              </PopoverContent>
            </Popover>
          </li>
          <li>
            <div style={{ width: '200px', float: 'left', marginBottom: '0px', color: 'black', fontFamily: body }}>
              <div>
                <Select
                  id='Navbar-Organisation-Select'
                  className='org-select-dropdown'
                  value={selectedOrganisation}
                  options={organisationOptions}
                  components={{ Option: CustomOption('Navbar-Organisation-Select') }}
                  onChange={(organisationOptions) => {
                    updateOrg(organisationOptions);
                    if (history.location.pathname.includes('report')) {
                      history.push('/reports');
                    } else if (history.location.pathname.includes('consumption')) {
                      history.push('/reports');
                    } else if (history.location.pathname.includes('monthlyreport')) {
                      history.push('/reports');
                    }
                  }}
                />
              </div>
            </div>
          </li>
          <li>
            <div className='toggle-right-box hidden md:block'>
              <div
                onClick={toggleHelp}
                className='w-9 h-9 rounded-full bg-[var(--info-button)] hover:bg-[var(--info-button-hover)] flex items-center justify-center cursor-pointer transition-colors'>
                <Info size={14} strokeWidth={1.5} className='text-white' />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { whiteLabelId } = state.whiteLabelAdmin || {};
  const organisations = state.admin?.organisations
    ? [...state.admin.organisations, ...state.organisation.list]
    : state.organisation?.list;

  const currentOrganisation = state?.organisation?.details;
  const drgWhiteLabel = whiteLabelId === '7a258d61-0e9f-4d82-9a57-a1f207d483c2';

  const currentOrg = state?.currentOrganisation;

  const profileDetails = state.profile?.details?.profile ? state.profile.details.profile : state.profile.details;

  const organisationOptions = organisations?.map((organisation) => ({
    value: organisation.id,
    label: organisation.name,
  }));

  const uniqueOrgs = _.uniqBy(organisationOptions, 'value');

  const selectedOrganisation = currentOrg && _.find(organisationOptions, { value: currentOrg });

  return {
    showHelpSidebar: state?.help?.show,
    currentOrg,
    organisations,
    currentOrganisation,
    selectedOrganisation,
    organisationOptions: _.sortBy(uniqueOrgs, ['label']),
    fullName:
      profileDetails &&
      [profileDetails.firstName, profileDetails.lastName].filter(Boolean).join(' ').trim(),
    branding: state.branding,
    brandingAssetPreview: state.brandingAssetPreview,
    drgWhiteLabel,
    profile: state.profile?.details,
    isWhiteLabelApp: state.isWhiteLabelApp,
  };
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(LOGINACTIONS.logout()),
  loginWithAws: () => dispatch(LOGINACTIONS.loginWithAws()),
  updateOrganisation: (organisation) => dispatch(ORGANISATIONACTIONS.updateOrganisation(organisation)),
  getOrganisation: () => dispatch(ORGANISATIONACTIONS.getOrganisation()),
  toggleSidebar: () => dispatch(SIDEBARACTIONS.toggleSidebar()),
  toggleHelp: () => dispatch(HELPACTIONS.showHelp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
